// components/ProtectedRoute.js
import { FC, useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router";
// import { useAuth } from "./useAuth";
import { PATH_AUTH, PATH_DASHBOARD } from "../routes/path";
import { Box } from "@mui/material";
import { LoadingSpinner } from "../components/ui-elements/svg-icons";
import { useDispatch, useSelector } from "react-redux";
import {
  initialize_storage_data,
  is_user_authenticated,
} from "../utils/storage";
import {
  setAccount_profile_data,
  setOnboarded,
  setVerified,
} from "../store/contentSlice";
import { RootState } from "../store/store";

interface AuthGuardProps {
  children: React.ReactNode;
}

const AuthGuard: FC<AuthGuardProps> = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const verified = useSelector((state: RootState) => state.content.verified);
  const [guard_data, setGuard_data] = useState({
    isLoading: true,
    access: false,
    verified: false,
  });

  useEffect(() => {
    const loadStorageData = async () => {
      const storageData = await initialize_storage_data();

      // Update Redux store with the loaded data
      dispatch(setVerified(storageData.verified));
      dispatch(setAccount_profile_data(storageData.account_profile));
    };
    loadStorageData();
  }, [dispatch]);

  useEffect(() => {
    checkAuthStatus();
  }, []);

  const checkAuthStatus = async () => {
    const auth_value = await is_user_authenticated();
    if (auth_value) {
      setGuard_data((prev) => ({ ...prev, access: true }));
    } else {
      setGuard_data((prev) => ({ ...prev, access: false }));
    }
    setGuard_data((prev) => ({ ...prev, isLoading: false }));
  };

  if (guard_data.isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          width: "100%",
        }}
      >
        {/* {[...Array(2)].map((_, idx) => (
          <SkeletonLoading key={idx} />
        ))} */}
      </Box>
    );
  }

  return (
    <>
      {guard_data?.access ? (
        children
      ) : (
        // If not authenticated, render login page
        <Navigate to={PATH_AUTH.signIn} />
      )}
    </>
  );
};

export default AuthGuard;
